import { useEffect, useState } from 'react'

import { usePathname } from 'next/navigation'

function useQueryParams(query: string) {
  const [loaded, setLoaded] = useState(false)

  const pathname = usePathname()

  useEffect(() => {
    setLoaded(true)
  }, [])

  if (typeof window === 'undefined') {
    return { get: () => null, set: () => {}, push: () => {}, loaded }
  }

  function get(): string | null {
    if (!query) {
      return null
    }

    return new URLSearchParams(window.location.search).get(query)
  }

  function set(value: string, replace = true): void {
    if (!query) {
      return
    }

    const params = new URLSearchParams(window.location.search)
    params.set(query, value)
    const newSearch = params.toString()
    const newPath = newSearch ? `${pathname}?${newSearch}` : pathname

    if (replace) {
      window.history.replaceState(null, '', newPath)
    } else {
      window.history.pushState(null, '', newPath)
    }
  }

  function push(value: string): void {
    set(value, false)
  }

  return { get, set, push, loaded }
}

export default useQueryParams
